let audio: HTMLAudioElement | null = null;

export const playNotificationSound = () => {
	if (!audio) {
		audio = new Audio(
			'https://storage.googleapis.com/newo-static-files/sounds/notification-bell-sound.mp3'
		);
		audio.preload = 'auto';
	}

	audio.currentTime = 0;
	audio.play().catch(() => {});
};
